import { useRoute } from 'vue-router'

export function useGlobalPreview() {
  const route = useRoute()

  return route?.query?.preview
}
